import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_list_management_coverages" }
];

const CoveragesListing = Loadable({
  loader: () => import("container/management/coverages"),
  loading() {
    return <Loader />;
  }
});

export const coverageRoutes: IRoute[] = [
  {
    path: "/management/coverages",
    element: <CoveragesListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
